<template>
    <Button
        type="submit"
        class="relative"
        :disabled="disabled"
        :theme="theme"
        :size="size"
        :class="{
            'cursor-not-allowed opacity-50': disabled,
            'cursor-wait': submitting
        }">
        <span :class="{'invisible': submitting}">
            <slot></slot>
        </span>
        <span v-if="submitting" ref="indicator" class="block absolute inset-0 flex justify-center items-center">
            <svg class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </span>
    </Button>
</template>


<script>

import Button from "@/Components/Button";

export default {
    props: {
        theme: {
            type: String,
            default: 'primary'
        },
        size: {
            type: String,
            default: 'md'
        },
        submitting: {
            required: true,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        },
    },

    components: {
        Button
    },
};

</script>
